
import { mapGetters } from 'vuex'

export default {
    props: {
        idOrNameOrAgent: {
            type: [Number, String, Object],
            default: null
        },
        agentActive: {
            type: Boolean,
            default: null
        },
        // The client whose owning agent this badge represents. Required to enable
        // editing (we PATCH this client's survey to persist the new agent).
        clientId: {
            type: [Number, String],
            default: null
        },
        // Opt in to the agent-picker modal. Editing is still gated to canAgent users.
        editable: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            agent: null,
            selectedAgent: null,
            saving: false,
        }
    },
    async fetch () {
        if (typeof this.idOrNameOrAgent === 'object') {
            this.agent = this.idOrNameOrAgent
            return
        }
        if (typeof this.idOrNameOrAgent === 'string') {
            this.agent = {
                first_name: this.idOrNameOrAgent,
                last_name: '',
                active: this.agentActive == null ? this.agentActive : this.agentActive
            }
            return
        }
        this.agent = await this.$try('getClientAgent', this.idOrNameOrAgent)
    },
    computed: {
        ...mapGetters(['canAgent']),
        canEdit () {
            return this.editable && this.canAgent && !!this.clientId
        },
        modalId () {
            return `client-agent-modal-${this._uid}`
        },
    },
    methods: {
        openModal () {
            this.selectedAgent = null
            this.$bvModal.show(this.modalId)
        },
        async save () {
            if (!this.selectedAgent || this.saving) {
                return
            }
            this.saving = true
            const resp = await this.$try('updateSurvey', {
                id: this.clientId,
                data: { agent_id: this.selectedAgent.id }
            })
            this.saving = false
            if (resp?.error) {
                return
            }
            this.agent = this.selectedAgent
            // Keep the store's client in sync if this badge is for the loaded survey,
            // so the rest of the UI reflects the new agent without a reload.
            if (this.$store.getters.client?.id === this.clientId) {
                this.$store.commit('field', { field: 'agent', value: this.selectedAgent })
            }
            this.$emit('updated', this.selectedAgent)
            this.$bvModal.hide(this.modalId)
        },
    },
}
